import type { Language } from '../types'

export type VoiceInputErrorCode =
  | 'UNSUPPORTED'
  | 'PERMISSION_DENIED'
  | 'RECORDING_FAILED'
  | 'NETWORK_FAILED'
  | 'TRANSCRIPTION_FAILED'
  | 'RECOGNITION_FAILED'
  | 'ENDED'

export class VoiceInputError extends Error {
  constructor(
    readonly code: VoiceInputErrorCode,
    readonly upstreamCode?: string,
  ) {
    super(code)
    this.name = 'VoiceInputError'
  }
}

export interface VoiceInputProvider {
  readonly available: boolean
  listen(language: Language): Promise<string>
}
